import {
    ApplicationConfig,
    DEFAULT_CURRENCY_CODE,
    ErrorHandler,
    importProvidersFrom,
    isDevMode,
    LOCALE_ID,
    provideZoneChangeDetection
} from "@angular/core";
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {ExtraOptions, provideRouter, withRouterConfig} from "@angular/router";
import {routes} from "./app.routes";
import {GlobalErrorHandler} from "./app-error-handler";
import {providePrimeNG} from "primeng/config";
import {ThemePreset} from "../primeng-theme";
import {provideHighcharts} from 'highcharts-angular';
import {AgGridModule} from "ag-grid-angular";
import {MessageService} from "primeng/api";
import {provideSignalFormsConfig} from "@angular/forms/signals";
import {provideServiceWorker} from '@angular/service-worker';
import {patchDynamicDialogDefaults} from "./shared/dialog-defaults";
import {sweepLegacyStorage} from "./shared/storage/legacy-storage-sweep";

patchDynamicDialogDefaults();
// Before any component field initializer reads a key: the pages seed their column selection there.
sweepLegacyStorage();

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
    bindToComponentInputs: true,
    // enableTracing: true,
};


/*function detectLocale() {
    const l = navigator.language;
    switch (l) {
        case "en-HK":
        case "it-IT":
        case "it-CH":
            return l;
        default:
            return "en-US";
    }
}*/

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection(),
        // {provide: LocationStrategy, useClass: HashLocationStrategy}, // Breaks login callback
        {provide: DEFAULT_CURRENCY_CODE, useValue: 'USD'},
        // {provide: LOCALE_ID, useValue: detectLocale()},
        {provide: LOCALE_ID, useValue: 'it-US'},
        {provide: ErrorHandler, useClass: GlobalErrorHandler},

        importProvidersFrom([AgGridModule]),
        provideSignalFormsConfig({}),
        provideHighcharts({
            // Global chart options applied across all charts
            options: {
                chart: {
                    backgroundColor: 'transparent',
                },
                title: {
                    style: {
                        color: 'tomato',
                    },
                },
                legend: {
                    enabled: false,
                },

                navigation: {
                    iconsURL: "highcharts-gfx/stock-icons/"
                },
            },

            // Include Highcharts additional modules (e.g., exporting, accessibility) or custom themes
            modules: () => {
                return [
                    // import('highcharts/esm/modules/accessibility'),
                    // import('highcharts/esm/modules/exporting'),
                    import('highcharts/esm/modules/stock-tools'),
                    import('highcharts/esm/modules/annotations'),
                    import('highcharts/esm/modules/annotations-advanced'),
                    import('highcharts/esm/modules/stock'),
                    import('highcharts/esm/modules/xrange'),
                    import('highcharts/esm/modules/heatmap'),
                    import('highcharts/esm/themes/sunset'),
                ];
            },
        }),
        provideHttpClient(withInterceptorsFromDi()),
        provideRouter(routes, withRouterConfig(routerOptions)),
        providePrimeNG({
            theme: {
                preset: ThemePreset,
                options: {darkModeSelector: '.app-dark'}
            },
            // Italian / European calendar convention — start the week on Monday
            // so p-datepicker matches FullCalendar's `firstDay: 1` everywhere.
            translation: {firstDayOfWeek: 1},
        }),
        MessageService,
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:5000'
        })
    ]
};
